import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ChevronMiniUp = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="currentColor"
    title={t`Chevron Mini Up`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="m4.354.354 2.792 2.792A.5.5 0 0 1 6.793 4H1.207a.5.5 0 0 1-.353-.854L3.646.354a.5.5 0 0 1 .708 0Z"
    />
  </Icon>
);
